import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { MESSAGE_TYPE } from '../models/Message.enums'
import type { TCreateMessagePayload } from './types/createMessageApi.types'
import type { TReplyToUpliftPayload, TReplyToUpliftResponse } from './types/createReplyForUpliftMessageApi.types'
import type {
  TGetConversationMessagesData,
  TGetConversationMessagesPayload,
} from './types/getConversationMessagesApi.types'
import type { TGetConversationsData, TGetConversationsPayload } from './types/getConversationsApi.types'
import type { TConversationApi, TFullMessageApi } from './types/messageApi.types'

export const messageApi = {
  createMessage: <Type extends MESSAGE_TYPE>(payload: TCreateMessagePayload<Type>) =>
    fetcher.mutate<TFullMessageApi<Type>, TCreateMessagePayload<Type>>('/message', payload, {
      method: 'POST',
    }),
  createReplyForUpliftMessage: (payload: TReplyToUpliftPayload) =>
    fetcher.mutate<TReplyToUpliftResponse, TReplyToUpliftPayload>('/messageReplyToUplift', payload, {
      method: 'POST',
    }),
  deleteMessage: (messageId: number) =>
    fetcher.mutate<void, undefined>(`/message/${messageId}`, undefined, { method: 'DELETE' }),
  blockConversation: (conversationId: number) =>
    fetcher.mutate<void, undefined>(`/conversation/${conversationId}/block`, undefined, { method: 'POST' }),
  unblockConversation: (conversationId: number) =>
    fetcher.mutate<void, undefined>(`/conversation/${conversationId}/unblock`, undefined, { method: 'POST' }),
  getConversations: (params: TGetConversationsPayload, { signal }: TSignalConfig) =>
    fetcher.query<TGetConversationsData>('/me/conversations', { params, signal }),
  getSingleConversation: (id: number, { signal }: TSignalConfig) =>
    fetcher.query<TConversationApi>(`/conversation/${id}`, {
      signal,
    }),
  getConversationMessages: (
    { conversationId, ...params }: TGetConversationMessagesPayload & { conversationId: number },
    { signal }: TSignalConfig,
  ) => fetcher.query<TGetConversationMessagesData>(`/conversation/${conversationId}/messages`, { params, signal }),
  markConversationAsUnread: (messageId: number) =>
    fetcher.mutate<void, undefined>(`/message/${messageId}/unread`, undefined, {
      method: 'POST',
    }),
}
